import React, { useState, useEffect } from "react";
import styles from "./Webcam.module.scss";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import CameraVideo from "../../../../img/camplant.webp";
import camera1 from "../../../../img/camera1.webp";
import camera2 from "../../../../img/camera2.webp";
import camera3 from "../../../../img/camera3.webp";
import camera4 from "../../../../img/camera4.webp";
import getRequest from "../../../../helpers/getRequest";
import Table from "../../../Finances/Components/Table/Table";
import tokenNew from "../../../../img/nftDesign2.webp";
import { useTranslation } from "react-i18next";

const Main = () => {
  const [plants, setPlants] = useState([]);
  const [plantBalance, setPlantBalance] = useState(null);
  const [plantsTillMay, setPlantsTillMay] = useState([]);
  const [totalPlantsTillMay, setTotalPlantsTillMay] = useState(0);
  const [plantsJuneJuly, setPlantsJuneJuly] = useState([]);
  const [totalPlantsJuneJuly, setTotalPlantsJuneJuly] = useState(0);
  const [plantsFromAugust, setPlantsFromAugust] = useState([]);
  const [totalPlantsFromAugust, setTotalPlantsFromAugust] = useState(0);

  useEffect(() => {
    getRequest("v1/finances/data")
      .then((response) => {
        setPlantsTillMay([
          response.data.plantsDetails
            .filter((item) => {
              return (new Date(item.purchase_date).getMonth() <= 4 && new Date(item.purchase_date).getFullYear()==2024) || new Date(item.purchase_date).getFullYear()<2024;
            })
            .reduce(
              (acc, val) => ({
                ...acc,
                total_amount: acc.total_amount + Number(val.total_amount),
                plants_count: acc.plants_count + Number(val.plants_count),
              }),
              { total_amount: 0, plants_count: 0 }
            ),
        ]);
        setTotalPlantsTillMay(
          response.data.plantsDetails
            .filter((item) => {
              return (new Date(item.purchase_date).getMonth() <= 4 && new Date(item.purchase_date).getFullYear()==2024) || new Date(item.purchase_date).getFullYear()<2024;
            })
            .reduce(
              (acc, val) => ({
                ...acc,
                total_amount: acc.total_amount + Number(val.total_amount),
                plants_count: acc.plants_count + Number(val.plants_count),
              }),
              { total_amount: 0, plants_count: 0 }
            ).plants_count
        );

        setPlantsJuneJuly([
          response.data.plantsDetails
            .filter((item) => {
              const month = new Date(item.purchase_date).getMonth();
              return month >= 5 && month <= 6 && new Date(item.purchase_date).getFullYear()==2024;
            })
            .reduce(
              (acc, val) => ({
                ...acc,
                total_amount: acc.total_amount + Number(val.total_amount),
                plants_count: acc.plants_count + Number(val.plants_count),
              }),
              { total_amount: 0, plants_count: 0 }
            ),
        ]);

        setTotalPlantsJuneJuly(
          response.data.plantsDetails
            .filter((item) => {
              const month = new Date(item.purchase_date).getMonth();
              return month >= 5 && month <= 6 && new Date(item.purchase_date).getFullYear()==2024;
            })
            .reduce(
              (acc, val) => ({
                ...acc,
                total_amount: acc.total_amount + Number(val.total_amount),
                plants_count: acc.plants_count + Number(val.plants_count),
              }),
              { total_amount: 0, plants_count: 0 }
            ).plants_count
        );

        setPlantsFromAugust([
          response.data.plantsDetails
            .filter((item) => {
              return (new Date(item.purchase_date).getMonth() >= 7 && new Date(item.purchase_date).getFullYear()==2024)|| new Date(item.purchase_date).getFullYear()>2024;
            })
            .reduce(
              (acc, val) => ({
                ...acc,
                total_amount: acc.total_amount + Number(val.total_amount),
                plants_count: acc.plants_count + Number(val.plants_count),
              }),
              { total_amount: 0, plants_count: 0 }
            ),
        ]);

        setTotalPlantsFromAugust(
          response.data.plantsDetails
            .filter((item) => {
              return ( new Date(item.purchase_date).getMonth() >= 7 && new Date(item.purchase_date).getFullYear()==2024)|| new Date(item.purchase_date).getFullYear()>2024;
            })
            .reduce(
              (acc, val) => ({
                ...acc,
                total_amount: acc.total_amount + Number(val.total_amount),
                plants_count: acc.plants_count + Number(val.plants_count),
              }),
              { total_amount: 0, plants_count: 0 }
            ).plants_count
        );

        setPlants([
          response.data.plantsDetails.reduce(
            (acc, val) => ({
              ...acc,
              total_amount: acc.total_amount + Number(val.total_amount),
              plants_count: acc.plants_count + Number(val.plants_count),
            }),
            { total_amount: 0, plants_count: 0 }
          ),
        ]);
      })
      .catch((error) => {
        console.log(error);
      });
    getRequest("v1/dashboard/balance").then((response) => {
      setPlantBalance(response?.data?.plantsBalance);
    });

    console.log(plantsTillMay)
  }, []);

  const { t } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 840);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 840);
    }

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className={styles.webcam}>
      {plants && plantBalance != 0 ? (
        <div className={styles.webcam__header}>
          <SectionTitle
            text={`${t("My tokens")} (${Number(plantBalance)
              .toFixed(2)
              .replace(".", ",")}) `}
          />
        </div>
      ) : null}
      
      {plantsTillMay && totalPlantsTillMay > 0 ? (
        <>
          <div className={styles.webcam__label}>
            <img src={tokenNew} alt="nft-1" width={60} />
            <div>
              <h5>{t("NFT")}</h5>
              <span>{t("Sorte 1")}</span>
            </div>
          </div>
          <div className={styles.webcam__wrapper}>
            <Table data={plantsTillMay} hasHeader={false} amountPayout="NFT Sorte 1"/>
          </div>
        </>
      ) : null}
      {plantsJuneJuly && totalPlantsJuneJuly > 0 ? (
        <>
          <div className={styles.webcam__label}>
            <img src={tokenNew} alt="nft-2" width={60} />
            <div>
              <h5>{t("NFT")}</h5>
              <span>{t("Sorte 2")}</span>
            </div>
          </div>
          <div className={styles.webcam__wrapper}>
            <Table data={plantsJuneJuly} hasHeader={false} amountPayout="NFT Sorte 2"/>
          </div>
        </>
      ) : null}

      {plantsFromAugust && totalPlantsFromAugust > 0 ? (
        <>
          <div className={styles.webcam__label}>
            <img src={tokenNew} alt="nft-3" width={60} />
            <div>
              <h5>{t("NFT")}</h5>
              <span>{t("Sorte 3")}</span>
            </div>
          </div>
          <div className={styles.webcam__wrapper}>
            <Table data={plantsFromAugust} hasHeader={false} amountPayout="NFT Sorte 3"/>
          </div>
        </>
      ) : null}
      <div className={styles.webcam__header}>
        <SectionTitle text={t("Webcams")} />
      </div>
      <div className={styles.webcam__wrapper}>
        <div className={styles.webcam__mainCamera}>
          <div className={styles.webcam__mainCamera__offline}>
            {t("Live Camera will be activated soon")}
          </div>
          <img src={CameraVideo} alt="video" />
          <div className={styles.webcam__mainCamera_info}>
            <div className={styles.webcam__mainCamera_info_wrapper}>
              <div>{t("Webcam")} 1234</div>
              <div className={styles.webcam__mainCamera_info_separator}></div>
              <div>{t("sector")} 002 </div>
            </div>
            <div className={styles.webcam__mainCamera_info_wrapper}>
              <div>{t("local time")}</div>
              <div>09:38 am</div>
            </div>
          </div>
        </div>
        {/* <div className={cn(styles.webcam__tabs, styles.webcam__tabsMob)}>
            <div
              className={cn(
                styles.webcam__tab,
                tab === 1 ? styles.webcam__tab_active : ""
              )}
              onClick={() => setTab(1)}
            >
              <LikeIcon />
              <div>{t("My tokens")}</div>
              <div>(0)</div>
            </div>
            <div
              className={cn(
                styles.webcam__tab,
                tab === 2 ? styles.webcam__tab_active : ""
              )}
              onClick={() => setTab(2)}
            >
              <CameraIcon />
              <div>{t("Webcams online")}</div>
              <div>(0)</div>
            </div>
          </div> */}
        <div className={styles.webcam__cameras}>
          <div className={styles.webcam__cameras_item}>
            <div className={styles.webcam__cameras_item__image}>
              <div className={styles.webcam__cameras_item_offline}>
                {t("Live Camera will be activated soon")}
              </div>
              <img src={camera1} alt="camera" />
            </div>

            {/* <img className={styles.webcam__cameras_item_online} src={online} alt="online"/> */}
            <div className={styles.webcam__cameras_item_info}>
              <div>{t("Webcam")} 1234</div>
              <div>{t("sector")} 002 </div>
            </div>
          </div>
          <div className={styles.webcam__cameras_item}>
            <div className={styles.webcam__cameras_item__image}>
              <div className={styles.webcam__cameras_item_offline}>
                {t("Live Camera will be activated soon")}
              </div>
              <img src={camera2} alt="camera" />
            </div>
            {/* <img className={styles.webcam__cameras_item_play}  src={play} alt="play"/> */}
            <div className={styles.webcam__cameras_item_info}>
              <div>{t("Webcam")} 1234</div>
              <div>{t("sector")} 002 </div>
            </div>
          </div>
          <div className={styles.webcam__cameras_item}>
            <div className={styles.webcam__cameras_item__image}>
              <div className={styles.webcam__cameras_item_offline}>
                {t("Live Camera will be activated soon")}
              </div>
              <img src={camera3} alt="camera" />
            </div>
            {/* <img className={styles.webcam__cameras_item_play}  src={play} alt="play"/> */}
            <div className={styles.webcam__cameras_item_info}>
              <div>{t("Webcam")} 1234</div>
              <div>{t("sector")} 002 </div>
            </div>
          </div>
          <div className={styles.webcam__cameras_item}>
            <div className={styles.webcam__cameras_item__image}>
              <div className={styles.webcam__cameras_item_offline}>
                {t("Live Camera will be activated soon")}
              </div>
              <img src={camera4} alt="camera" />
            </div>
            {/* <img className={styles.webcam__cameras_item_play}  src={play} alt="play"/> */}
            <div className={styles.webcam__cameras_item_info}>
              <div>{t("Webcam")} 1234</div>
              <div>{t("sector")} 002 </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Main;
